import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Ana', 'Diego', 'Lucía', 'Martín', 'Carolina', 'Roberto', 'Sofía'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (random 8-12s)
      const nextDelay = Math.random() * 4000 + 8000;
      setTimeout(triggerNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full" data-id="element-2">
          <div className="bg-white text-neutral-900 p-4 rounded-lg shadow-2xl border-l-4 border-green-500 flex items-center gap-3" data-id="element-3">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-4">
              <CheckCircleIcon className="w-5 h-5 text-green-600" data-id="element-5" />
            </div>
            <div data-id="element-6">
              <p className="text-sm font-medium" data-id="element-7">
                <span className="font-bold" data-id="element-8">{notification.name}</span> de{' '}
                {notification.city}
              </p>
              <p className="text-xs text-neutral-500" data-id="element-9">
                acaba de comprar este libro digital
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}